import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-lms2",
  "use": "icon-lms2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-lms2\"><path fill=\"#696969\" d=\"M979.199 725.347v-85.347l-382.266-256V85.347s0-85.347-84.934-85.347-84.934 85.347-84.934 85.347v298.653l-382.266 256v85.347l382.266-128v238.95L299.667 938.649v85.351l212.333-85.351 212.333 85.351v-85.351L596.934 836.297v-238.95l382.265 128z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol